import { Provider } from 'jotai';
import React, { useEffect, useMemo, useState } from 'react';
import UsageDashboard from '@src/components/usage-dashboard';
import { initStore } from '@src/components/usage-dashboard/atoms';
import { StyledDrawer } from './styled';
import { ErrorBoundary } from '@src/components/common';

const UsageDashboardPage = () => {
  const eventName = 'open-usage-dashboard';
  const [openDrawer, setOpenDrawer] = useState(false);

  const store = useMemo(() => {
    return initStore();
  }, []);

  const handleDrawerOpenClose: any = () => {
    setOpenDrawer(!openDrawer);
  };
  useEffect(() => {
    window.addEventListener(eventName, handleDrawerOpenClose);
    return () => {
      window.removeEventListener(eventName, handleDrawerOpenClose);
    };
  }, []);

  return (
    <div data-ifc-event={eventName}>
      <Provider store={store}>
        <StyledDrawer
          open={openDrawer}
          onClose={handleDrawerOpenClose}
          styles={{
            wrapper: {
              width: '85%',
              minWidth: '800px',
            },
            body: {
              padding: 0,
            },
          }}
        >
          <ErrorBoundary>
            <UsageDashboard />
          </ErrorBoundary>
        </StyledDrawer>
      </Provider>
    </div>
  );
};

export default UsageDashboardPage;
